import { HttpClient } from '@angular/common/http';
import { environment } from '@prcins/environments';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CancellationProviderService {
    constructor(http) {
        this.http = http;
        this.apiUrl = environment.BASE_URL + '/v2/';
    }
    /**
     * Creates a cancellation endorsement and returns the guid
     */
    createCancellationEndorsement(type = 'PC') {
        const policyNum = sessionStorage.getItem('currentPolicy');
        return this.http.post(this.apiUrl + 'core/' + policyNum + '/endorsements/cancellation', {});
    }
    /**
     * Checks if a cancellation request already exists for the policy
     */
    checkCancellationRequestExists(policyNum) {
        return this.http.get(environment.BASE_URL + '/policy/cancellation/exists/' + policyNum);
    }
    checkCancellationEligibility(policyNum) {
        return this.http.get(environment.BASE_URL + '/policy/cancellation/' + policyNum);
    }
    submitCancellationRequest(policyNumber, guid, request) {
        const url = environment.BASE_URL + '/policy/cancellation/' + policyNumber + '/endorsements/' + guid;
        return this.http.post(url, request);
    }
    /**
     * Validates uploaded cancellation documents
     */
    validateCancellationDocuments(formData, policyNum, guid) {
        const url = guid
            ? environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments/' + guid
            : environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments';
        return this.http.post(url, formData);
    }
}
CancellationProviderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CancellationProviderService_Factory() { return new CancellationProviderService(i0.ɵɵinject(i1.HttpClient)); }, token: CancellationProviderService, providedIn: "root" });
